<template>
  <div id="modalQRCode">
    <div name="modal">
      <div class="modal-mask">
        <div class="modal-wrapper" @click="fecharQrCode()">
          <div class="modal-container w3-modal-content" @click.stop>
            <header class="w3-container modal-wrapper ">
              <span @click="fecharQrCode()" class="w3-button w3-display-topright">&times;</span>  
              <h5 class="texto-vermelho titulo"><i class="fas fa-qrcode"></i> Leitor QrCode</h5>
            </header>
            <qrcode-stream class="w3-col" @decode="onDecode" @init="onInit" />  
            <div> 
                <button class="w3-button w3-theme" @click="fecharQrCode()" style="margin: auto; margin-top: 10px; margin-bottom:10px" >
                  Fechar
                </button> 
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import toastr from 'toastr'
import { QrcodeStream } from 'vue-qrcode-reader';

  export default {
    name: 'ModalCode',
    components: {
      QrcodeStream
    },
    data() {
      return {
        api: process.env.API,
        result: '',
        error: '',

        readerSize: {
          width: 200, 
          height: 280
        },    
      }
    },

    methods: {
      onDecode (result) {
        this.result = result
        this.$emit('atualizar', this.result)
        this.fecharQrCode()
      },

      async onInit (promise) {
        try {
          await promise
        } catch (error) {
          if (error.name === 'NotAllowedError') {
            this.error = "ERRO: você precisa conceder permissão de acesso à câmera!"
          } else if (error.name === 'NotFoundError') {
            this.error = "ERRO: nenhuma câmera neste dispositivo!"
          } else if (error.name === 'NotSupportedError') {
            this.error = "ERRO: contexto seguro exigido (HTTPS, localhost)!"
          } else if (error.name === 'NotReadableError') {
            this.error = "ERRO: Câmera já em uso?"
          } else if (error.name === 'OverconstrainedError') {
            this.error = "ERRO: câmeras instaladas não são adequadas!"
          } else if (error.name === 'StreamApiNotSupportedError') {
            this.error = "ERRO: a API de fluxo não é suportada neste navegador!"
          }         
        }
        if (this.error != '') {
            toastr.error(this.error);
            this.fecharQrCode()            
        } 
      },
      fecharQrCode() {
        this.$emit('close');
        return
      },
    },
  }
</script>
<style scoped>
  .card-informacoes {
    margin-bottom: 10px;
    border-left-style: solid;
    border-left-color: #636363;
    border-bottom-style: solid;
    border-bottom-width: 1px;
    float: left;
    padding: 7px;
    border-bottom-color: #636363 !important;
    cursor: pointer;
    transition: 0.2s;
    width: 100%
  }
  .card-informacoes-selecionado {
    border-left-color : #9c1d1c !important;
    background:#9c1d1c2e
  }
  .modal-mask {
    position: fixed;
    z-index: 9998;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, .5);
    display: table;
    transition: opacity .3s ease;
  }

  .modal-wrapper {
    display: table-cell;
    vertical-align: middle;
  }
  @media (min-width: 993px){
    .modal-container {
        width: 1010px;
    }
    #modalQRCode .modal-container{
      width:640px;
    }
  }
  @media (max-width: 768px){
    .modal-container {
        width: 600px;
    }
  }
  @media (max-width: 605px){
    .modal-container {
        width: 320px !important;
        
    }
    .container-items {
      max-height: 230px !important;
    }
  }  
  .modal-container {
    border-radius: 12px ;
    margin: auto;
    height: auto;
    padding: 10px 10px;
    background-color: #fff;
    box-shadow: 0 2px 8px rgba(0, 0, 0, .33);
    transition: all .3s ease;
    font-family: Helvetica, Arial, sans-serif;
    animation: animatezoom 0.6s;
  }

  .modal-header h3 {
    margin-top: 0;
    color: #42b983;
  }

  .modal-body {
    margin: 20px 0;
  }

  .modal-default-button {
    float: right;
  }

  .modal-enter {
    opacity: 0;
  }

  .modal-leave-active {
    opacity: 0;
  }

  .modal-enter .modal-container,
  .modal-leave-active .modal-container {
    -webkit-transform: scale(1.1);
    transform: scale(1.1);
  }
  button {
      background: #9c1d1c;
      color: white;
      padding: 10px;
      border: 0 !important
  }
  .tr-titulo {
    padding: 10px !important;
    background: #565454b8;
    color:white
  }
  .processar-btn {
    margin-top: 10px;
    padding: 5px;
  }
  .pesquisar-titulo {
    margin: auto;
    text-align: center;
    cursor: pointer;
    border: #636363 1px solid;
    padding: 10px;
    transition: 0.1s;
    background: #9c1d1c;
    color: white;
    margin-left: 10px;
    margin-right: 10px;
    margin-top: 22px;

  }
  .pesquisar-titulo:hover {
    background: white;
    color: black
  }
  .tr-items-ativo:hover {
    background: #9c1d1c69 !important;
  }
  .tr-items-ativo {
    background:#9c1d1c2e !important
  }
  .tr-items {
    cursor: pointer;
    transition: 0.2s
  }
  .tr-items:hover {
    background: #9c1d1cb8;
    color:#fff;
  }
  th {
    white-space: nowrap;
    background: silver;
    text-align: center
  }
  td {
    white-space: nowrap;
    text-align: center
  }
  .w3-input {
    border: 1px solid gray;
  }
  .container-items {
    max-height: 300px;
    overflow: auto;
  }
  .w3-container {
    padding: 0 !important
  }
  .w3-table td {
    padding: 4px 8px
  }

  ::-webkit-scrollbar {
    width: 5px;
    height: 5px;
  }

  ::-webkit-scrollbar-track {
    background: #ddd; 
  }
  
  ::-webkit-scrollbar-thumb {
    background: #8d1007; 
  }
  
  ::-webkit-scrollbar-thumb:hover {
    background: #9c1d1c; 
  }
</style>



// WEBPACK FOOTER //
// src/components/ModalQrCode.vue